export const EVENT_NAME = "Dark Carnival";
